export default "__VITE_ASSET__CR4J4JMp__"